import React from 'react';

import PropTypes from 'prop-types';
import Redirect from 'react-router-dom/Redirect';
import Route from 'react-router-dom/Route';
import Switch from 'react-router-dom/Switch';

import MatchWhenAuthorized from 'pages/MatchWhenAuthorized';
import NoMatch from 'pages/NoMatch';


import IframeJobList from './IframeJobList';
import IframeCostGroup from '../settings/IframeCostGroup';
import IframeRouteList from './IframeRouteList';
import IframeVarianceReport from '../settings/IframeVarianceReport';

const JobTrackRoutes = (props) => {
  const { match } = props;
  return (
    <Switch>
      <Redirect exact from={match.url} to={`${match.url}/list`} />
      <MatchWhenAuthorized
        exact
        path={`${match.url}/settings/VarianceReport`}
        name="jobTrack.settings.varianceReport"
        component={IframeVarianceReport}
      />
      <MatchWhenAuthorized
        exact
        path={`${match.url}/settings/costGroup`}
        name="jobTrack.settings.costGroup"
        component={IframeCostGroup}
      />
      <MatchWhenAuthorized
        exact
        path={`${match.url}/routes/list`}
        name="jobTrack.jobCentre.routes"
        component={IframeRouteList}
      />
      
      
      <Route component={NoMatch} />
    </Switch>
  );
};

JobTrackRoutes.propTypes = {
  match: PropTypes.object.isRequired,
};

export default JobTrackRoutes;
